define('viewmodels/modals/dialogs/VerifyMobileNumberDialog',['knockout'], function (ko) {

    var VerifyMobileNumberDialog = function (
        dialog,
        formFields,
        wpMobileNumber,
        player,
        settingsModel,
        Command,
        PlatformCommandDispatcher,
        values,
        validity,
        navigation
    ) {
        var self = this;

        self.dialog = dialog;
        self.topBarAction = ko.observable();
        self.topBar = ko.observable();
        self.verificationCode = values.text().mod(validity.minLength(4));

        self.contactInfo = player().contactInfo;

        self.translations = {
            title: wpMobileNumber('second_step_header'),
            tip: wpMobileNumber('enter_code_tip')
        };

        self.data = {
            field: formFields.textField(self.verificationCode),
            label: self.translations.tip.replacements({
                phoneNumber: self.contactInfo.phoneNumber.displayValue
            }),
            placeholder: ko.observable('    ')
        };

        self.verifyPhoneNumberCommand = new Command(
            new PlatformCommandDispatcher('verifyPhoneNumber/verify', 'common'), {
                phoneNumber: {
                    prefix: self.contactInfo.phoneNumber.prefix,
                    number: self.contactInfo.phoneNumber.number
                },
                verificationCode: self.verificationCode
            }
        );

        self.submitHandle = function () {
            return self.verifyPhoneNumberCommand.dispatchAsPromise().then(function () {
                self.close();
                navigation.navigate(navigation.ROUTES.SETTINGS);
            });
        };
    };

    VerifyMobileNumberDialog.prototype.close = function () {
        this.dialog.close(this);
    };

    return VerifyMobileNumberDialog;
});

